export const messages = {
  en: {
    aRoomDetailHisOwner: {
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      oweFee: 'Retained Arrears',
      oweFeeCount: 'Arrears Items',
      feeHandleType: 'Arrears Handling',
      feeHandleKeep: 'Keep',
      feeHandleTransfer: 'Transfer',
      feeHandleWriteOff: 'Write Off',
      transferOwnerName: 'Transfer Owner',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Record Time',
      changeType: 'Change Type',
      operatorUserName: 'Operator',
      remark: 'Remark',
      currentRelation: 'Current Relation',
      ownerExit: 'Owner Exit',
      relationInvalid: 'Relation Invalid',
      historyMigration: 'History Migration',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      loadError: 'Failed to load owner history'
    }
  },
  zh: {
    aRoomDetailHisOwner: {
      ownerName: '业主名称',
      ownerPhone: '业主电话',
      oweFee: '保留欠费',
      oweFeeCount: '欠费笔数',
      feeHandleType: '欠费处理',
      feeHandleKeep: '保留',
      feeHandleTransfer: '转移',
      feeHandleWriteOff: '核销',
      transferOwnerName: '转移业主',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '记录时间',
      changeType: '变更类型',
      operatorUserName: '操作人',
      remark: '变更备注',
      currentRelation: '当前关系',
      ownerExit: '业主退房',
      relationInvalid: '关系失效',
      historyMigration: '历史迁移',
      status: '状态',
      active: '在用',
      inactive: '失效',
      loadError: '加载历史业主失败'
    }
  },
  'zh-TW': {
    aRoomDetailHisOwner: {
      ownerName: '業主名稱',
      ownerPhone: '業主電話',
      oweFee: '保留欠費',
      oweFeeCount: '欠費筆數',
      feeHandleType: '欠費處理',
      feeHandleKeep: '保留',
      feeHandleTransfer: '轉移',
      feeHandleWriteOff: '核銷',
      transferOwnerName: '轉移業主',
      startTime: '開始時間',
      endTime: '結束時間',
      createTime: '記錄時間',
      changeType: '變更類型',
      operatorUserName: '操作人',
      remark: '變更備註',
      currentRelation: '當前關係',
      ownerExit: '業主退房',
      relationInvalid: '關係失效',
      historyMigration: '歷史遷移',
      status: '狀態',
      active: '在用',
      inactive: '失效',
      loadError: '載入歷史業主失敗'
    }
  }
}
